<template>
  <v-app>
    <!-- <div class="navv" @click.stop="drawer = !drawer" >
      <v-icon color="white" size="35" style="padding-left: 7px; padding-top: 8px;">
        menu
      </v-icon>
    </div> -->

    <v-navigation-drawer v-model="drawer" absolute temporary hide-overlay width="225" class="black">
      <div style="color: white;">
        <div style="width: 100%">
          <div class="navv-item" @click="nav('https://hydrafacial.com/')">
            Homepage
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/find-a-provider/')">
            Find a Provider
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/contact-us/')">
            Contact Us
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/the-treatment/')">
            The Treatment
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/results/')">
            Results
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/reviews/')">
            Reviews
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/press-page/')">
            Press
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/products/')">
            Products
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/faq/')">
            FAQ
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/about-us/')">
            About Us
          </div>
          <div class="navv-item" @click="nav('https://hydrafacial.com/careers/')">
            Careers
          </div>
          <div class="navv-item" @click="nav('https://hydrafacialco.com/')">
            For Professionals
          </div>
          
        </div>
      </div>
    </v-navigation-drawer>
    
    <nav-bar :toggleAdmin="toggleAdmin"/>
    <v-content style="background-color: black;">
      <admin v-if="showAdmin"/>
      <assessment v-else/>
    </v-content>
    <footer-bar/>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar';
import FooterBar from '@/components/FooterBar';
import Assessment from '@/views/Assessment';
import Admin from '@/views/Admin';

export default {
  name: 'app',
  components: {
    'nav-bar': NavBar,
    'footer-bar': FooterBar,
    assessment: Assessment,
    admin: Admin
  },
  data() {
    return {
      drawer: false,
      showAdmin: false
    };
  },
  methods: {
    toggleAdmin() {
      this.showAdmin = !this.showAdmin;
    },
    nav(link){
      window.open(link, '_self'); 

    }
  }
};
</script>

<style>
@font-face {
  font-family: "futura_pt_light";
    src: url('assets/FuturaPTLight.woff') format('woff');

}
@font-face {
  font-family: "bebas_neuebook";
    src: url('assets/bebasneuebook-webfont.woff2') format('woff2'),
         url('assets/bebasneuebook-webfont.woff') format('woff');

}
.navv{
  background-color: black; 
  position: absolute; 
  height: 52px; 
  width: 52px; 
  z-index:1;
  cursor: pointer;
}

.navv-item{
  padding-top: 17px;
  padding-left: 15px;
  cursor: pointer;
  height: 52px;
  font-size: 13.5px;
  list-style-type: none;
  border-bottom: 1px solid #212121
}

.navv-item:hover{
background-color: white;
color: black;
-webkit-transition: .3s; /* Safari */
  transition: .3s;
}

@media (min-width: 1161px){
.navv{
  display: none;
}

}


</style>
